import { NonEmptyArray } from '../../../packages/JsonQuery';

export function formatToJsonQueryTermsValue<T>(value: (T | null)[]) {
  if (value.length === 0 || value[0] === null) {
    return null;
  }

  return value as NonEmptyArray<T>;
}
